import Swal from "sweetalert2";
//sweet alerts for displaying error and info messages to the user and a loader
export default {
  methods: {
    // methods to show and close loader
    show_loader(message, minDisplayTime = 1000) {
      const loader = {
        startTime: Date.now(),
        minDisplayTime: minDisplayTime,
        isClosed: false,
        close: () => Swal.close()
      };

      return new Promise((resolve) => {
        Swal.fire({
          text: message,
          showConfirmButton: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          backdrop: 'rgba(0, 0, 0, 0.9)',
          customClass: {
            popup: 'system-loader-popup',
            htmlContainer: 'system-loader-text'
          },
          didOpen: () => {
            const popup = Swal.getPopup();
            const storedLogo = localStorage.getItem("loader_logo");
            const defaultLogo = window.__SYSTEM_LOADER_LOGO__ || require("@/assets/images/complyon/logos/aicone_logo_2.svg");
            const loaderLogo = storedLogo || defaultLogo;

            if (popup) {
              popup.style.setProperty("--loader-logo-url", `url("${loaderLogo}")`);
            }

            resolve(loader);
          }
        });
      });
    },

    /**
     * Closes the loader, ensuring it's shown for at least the minimum display time
     */
    async close_loader(loader) {
      if (!loader || loader.isClosed) return;

      const elapsed = Date.now() - loader.startTime;
      const remainingTime = loader.minDisplayTime - elapsed;

      if (remainingTime > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingTime));
      }

      loader.close();
      loader.isClosed = true;
    },
    show_error(message) {
      Swal.fire({
        icon: "error",
        text: message,
        showConfirmButton: true,
        customClass: {
          title: 'small-title',
          content: 'small-text'
        }
      })
    },
    show_confirm(title, text, confirmCallback, cancelCallback = null) {
      Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: {
          title: 'small-title',
          content: 'small-text'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          if (confirmCallback && typeof confirmCallback === 'function') {
            confirmCallback();
          }
        } else if (result.isDismissed) {
          if (cancelCallback && typeof cancelCallback === 'function') {
            cancelCallback();
          }
        }
      });
    },
    show_info(message) {
      Swal.fire({
        icon: "info",
        title: "Validation!",
        text: message,
        showConfirmButton: true,
        customClass: {
          title: 'small-title',
          content: 'small-text'
        }
      })
    },
    show_success(message) {
      Swal.fire({
        icon: "success",
        text: message,
        showConfirmButton: false,
        timer: 3500,
        customClass: {
          title: 'small-title',
          content: 'small-text'
        }
      })
    },
    close_modal(modal_id) {
      let modal_element = document.getElementById(modal_id);
      if (modal_element) {
        let modal_instance = window.bootstrap.Modal.getInstance(modal_element) || new window.bootstrap.Modal(modal_element);
        modal_instance.hide();
      }
    }
  },
};
